/**
 * Language Selector dropdown for Header
 */

import React, { useState, useEffect, useRef } from 'react';
import { useLanguage, SUPPORTED_LANGUAGES } from '../../contexts/LanguageContext';

const LanguageSelector = ({ compact = false }) => {
  const { language, changeLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = SUPPORTED_LANGUAGES.find((l) => l.code === language) || SUPPORTED_LANGUAGES[0];

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          padding: compact ? '4px 8px' : '6px 12px',
          background: 'transparent',
          border: '1px solid #e5e7eb',
          borderRadius: 6,
          cursor: 'pointer',
          fontSize: compact ? 12 : 14,
          color: '#374151',
        }}
        aria-label="Select language"
      >
        <span role="img" aria-label={current.name}>🌐</span>
        <span style={{ fontWeight: 500 }}>{current.native}</span>
        <span style={{ fontSize: 10 }}>▼</span>
      </button>

      {open && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 4px)',
            right: 0,
            minWidth: 180,
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: 8,
            boxShadow: '0 6px 18px rgba(0,0,0,0.10)',
            zIndex: 9999,
            maxHeight: 360,
            overflowY: 'auto',
          }}
        >
          {SUPPORTED_LANGUAGES.map((lang) => {
            const active = lang.code === language;
            return (
              <button
                key={lang.code}
                type="button"
                onClick={() => { changeLanguage(lang.code); setOpen(false); }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  padding: '8px 12px',
                  background: active ? '#fff7ed' : '#fff',
                  border: 'none',
                  cursor: 'pointer',
                  textAlign: 'left',
                  fontSize: 14,
                  color: active ? '#ea580c' : '#1f2937',
                  fontWeight: active ? 600 : 400,
                }}
                onMouseEnter={(e) => { if (!active) e.currentTarget.style.background = '#f9fafb'; }}
                onMouseLeave={(e) => { if (!active) e.currentTarget.style.background = '#fff'; }}
              >
                <span>
                  <span style={{ marginRight: 8 }}>{lang.native}</span>
                  <span style={{ color: '#9ca3af', fontSize: 12 }}>{lang.name}</span>
                </span>
                {active && <span style={{ color: '#ea580c' }}>✓</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
